/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { DOCUMENT: de },
  'en-US': { DOCUMENT: en },
  'es-ES': { DOCUMENT: es },
  'it-IT': { DOCUMENT: it },
  'pt-PT': { DOCUMENT: pt }
};
